export function useModals() {
  const activeModal = ref<string | undefined>();
  const isModalOpen = (modalName: string) => activeModal.value === modalName;

  function openModal(modalName: string) {
    activeModal.value = modalName;
  }

  function closeModal() {
    activeModal.value = undefined;
  }

  return {
    isModalOpen,
    openModal,
    closeModal,
  };
}
